import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ProfilePage = () => {
  const [user, setUser] = useState({ name: 'Václav Kolářík', email: 'vaclav@rezbarstvi.cz' });
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedOrder, setExpandedOrder] = useState(null); // Sledování rozkliknuté objednávky

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // Simulace načtení dat
        setTimeout(() => {
          setOrders([
            { 
              id: 'OBJ2026001', 
              date: '24.02.2026', 
              status: 'Na cestě', 
              total: '1 200 Kč',
              items: [
                { name: 'Ručně vyřezávaná miska z ořechu', price: '1 200 Kč' }
              ],
              address: 'Dlouhá 123, Svatobořice, 696 11'
            },
            { 
              id: 'OBJ2025112', 
              date: '15.11.2025', 
              status: 'Doručeno', 
              total: '2 500 Kč',
              items: [
                { name: 'Dřevěný drak - dekorace', price: '2 500 Kč' }
              ],
              address: 'Dlouhá 123, Svatobořice, 696 11'
            },
          ]);
          setLoading(false);
        }, 800);
      } catch (err) {
        console.error("Chyba při načítání profilu", err);
        setLoading(false);
      }
    };
    fetchUserData();
  }, []);

  const toggleOrder = (orderId) => {
    setExpandedOrder(expandedOrder === orderId ? null : orderId);
  };

  const handleLogout = () => {
    window.location.href = '/'; 
  };

  if (loading) return <div style={{paddingTop: '200px', textAlign: 'center'}}>Načítám profil...</div>;

  return (
    <div style={{ backgroundColor: '#f4e9dc', minHeight: '100vh', paddingTop: '140px', paddingBottom: '80px', color: '#2b1f18' }}>
      <div style={{ maxWidth: '1000px', margin: 'auto', padding: '0 20px' }}>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px' }}>
          <h1 style={{ fontSize: '2.5rem', margin: 0 }}>Můj účet</h1>
          <button onClick={handleLogout} style={logoutBtnStyle}>Odhlásit se</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
          
          {/* OSOBNÍ ÚDAJE */}
          <section style={cardStyle}>
            <h3 style={headerStyle}>Osobní údaje</h3>
            <p style={{marginBottom: '10px'}}><strong>Jméno:</strong> {user.name}</p>
            <p style={{marginBottom: '20px'}}><strong>Email:</strong> {user.email}</p>
            <button className="contact-button" style={{ fontSize: '0.8rem', width: 'auto' }}>Změnit heslo</button>
          </section>

          {/* MOJE AKTIVNÍ AUKCE */}
          <section style={cardStyle}>
            <h3 style={headerStyle}>Moje příhozy v aukcích</h3>
            <div style={itemRowStyle}>
              <div>
                <div style={{ fontWeight: 'bold' }}>Socha Strážce lesa</div>
                <div style={{ fontSize: '0.9rem', color: '#666' }}>Váš příhoz: 14 500 Kč</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <span style={statusBadgeStyle(false)}>přebito</span>
                <div style={{ fontWeight: 'bold', color: '#8b5a2b' }}>15 000 Kč</div>
              </div>
            </div>
            <div style={itemRowStyle}>
              <div>
                <div style={{ fontWeight: 'bold' }}>Reliéf Dub</div>
                <div style={{ fontSize: '0.9rem', color: '#666' }}>Váš příhoz: 3 200 Kč</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <span style={statusBadgeStyle(true)}>vedete</span>
                <div style={{ fontWeight: 'bold', color: '#8b5a2b' }}>3 200 Kč</div>
              </div>
            </div>
          </section>

          {/* HISTORIE OBJEDNÁVEK */}
          <section style={{ ...cardStyle, gridColumn: 'span 2' }}>
            <h3 style={headerStyle}>Moje objednávky</h3>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #d1b892', textAlign: 'left' }}>
                    <th style={tablePadding}>Číslo</th>
                    <th style={tablePadding}>Datum</th>
                    <th style={tablePadding}>Stav</th>
                    <th style={tablePadding}>Celkem</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.length > 0 ? orders.map(order => (
                    <React.Fragment key={order.id}>
                      <tr 
                        onClick={() => toggleOrder(order.id)} 
                        style={{ borderBottom: '1px solid #eee', cursor: 'pointer', backgroundColor: expandedOrder === order.id ? '#fcfaf7' : 'transparent' }}
                      >
                        <td style={tablePadding}>{order.id} {expandedOrder === order.id ? '▲' : '▼'}</td>
                        <td style={tablePadding}>{order.date}</td>
                        <td style={tablePadding}>{order.status}</td>
                        <td style={tablePadding}><strong>{order.total}</strong></td>
                      </tr>
                      
                      {/* DETAIL OBJEDNÁVKY */}
                      <AnimatePresence>
                        {expandedOrder === order.id && (
                          <tr>
                            <td colSpan="4" style={{ padding: 0 }}>
                              <motion.div 
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: 'auto', opacity: 1 }}
                                exit={{ height: 0, opacity: 0 }}
                                style={{ overflow: 'hidden', backgroundColor: '#fcfaf7', borderBottom: '1px solid #eee' }}
                              >
                                <div style={{ padding: '20px', fontSize: '0.9rem' }}>
                                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                                    <div>
                                      <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>Položky:</p>
                                      {order.items.map((item, i) => (
                                        <div key={i} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                          <span>{item.name}</span>
                                          <span>{item.price}</span>
                                        </div>
                                      ))}
                                    </div>
                                    <div>
                                      <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>Doručovací adresa:</p>
                                      <p>{order.address}</p>
                                    </div>
                                  </div>
                                </div>
                              </motion.div>
                            </td>
                          </tr>
                        )}
                      </AnimatePresence>
                    </React.Fragment>
                  )) : (
                    <tr><td colSpan="4" style={{padding: '20px', textAlign: 'center'}}>Zatím žádné objednávky.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
};

// --- STYLY ---
const cardStyle = {
  background: '#fff',
  padding: '30px',
  borderRadius: '15px',
  boxShadow: '0 10px 20px rgba(0,0,0,0.05)',
  display: 'flex',
  flexDirection: 'column'
};

const logoutBtnStyle = {
  background: 'transparent',
  border: '1px solid #8b5a2b',
  color: '#8b5a2b',
  padding: '8px 15px',
  borderRadius: '8px',
  cursor: 'pointer',
  fontWeight: '600'
};

const headerStyle = {
  borderBottom: '1px solid #f4e9dc',
  paddingBottom: '15px',
  marginBottom: '20px',
  fontSize: '1.2rem',
  color: '#8b5a2b'
};

const statusBadgeStyle = (isLeading) => ({
  fontSize: '0.75rem',
  padding: '3px 10px',
  borderRadius: '10px',
  background: isLeading ? '#d4edda' : '#f8d7da',
  color: isLeading ? '#155724' : '#721c24',
  fontWeight: 'bold'
});

const itemRowStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '12px 0',
  borderBottom: '1px solid #f9f9f9'
};

const tablePadding = { padding: '15px 10px' };

export default ProfilePage;